import React, { Component } from 'react';
import service from '../../core/service';
import { fixNumbers } from '../../core/utils';
import * as yup from 'yup'
import { toast } from 'react-toastify';


interface IProps {

}

interface IState {
  str: string;
  anchorEl: null | HTMLElement;
  open: any,
  value: string,
  openModal: boolean,
  openActionModal: boolean;
  loading: boolean;
  offersList: any;
  page: number;

  from_date: any,
  title: any,
  to_date: any,
  number: any,
  national_code: any,
  first_name: any,
  last_name: any,
  error: any;
  openUploadModal:boolean;
  file:any;
  fileUpload:any;
  uploadLoading:boolean;
  selecteditem:any;
  descr:string;
  uploadError:any;
  plan_type:string;
}

export class OffersListController extends Component<IProps, IState> {

  arrowRef: any;
  datePickerRef: any;

  constructor(props: any) {
    super(props);
    this.arrowRef = React.createRef();
    this.datePickerRef = React.createRef();

  }

  state: IState = {
    str: "",
    anchorEl: null,
    open: false,
    value: "",
    openModal: false,
    openActionModal: false,
    loading: false,
    offersList: [],
    page: 1,


    from_date: "",
    title: "",
    to_date: "",
    number: "",
    national_code: "",
    first_name: "",
    last_name: "",
    error: [],
    openUploadModal:false,
    file:"",
    fileUpload:"",
    uploadLoading:false,
  selecteditem:{},
  descr:"",
  uploadError:[],
  plan_type:""


  };
  id: any = this.state.open ? 'simple-popper' : undefined;

  search = async (e: any) => {
    this.setState({ str: e })
  };
  handleChange = (e: any) => {
    this.setState({ value: e.target.value })
  };

  handleClick = (event: any) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event?.currentTarget });
    this.setState({ open: this.state.anchorEl ? null : Boolean(event?.currentTarget) });
  };

  handleChangeFromDate = (value: any) => {
    this.setState({ from_date: value })

  };

  handleChangeToDate = (value: any) => {
    this.setState({ to_date: value })
  };


  getList = async () => {
    const {
      from_date,
      title,
      to_date,
      number,
      national_code,
      first_name,
      last_name , 
      plan_type} = this.state;

    this.setState({ loading: true })
    try {
      const response = await service.UniversalOffer.list(this.state.page, {
        from_date: from_date === "" ? null : fixNumbers(from_date.convert()?.format("YYYY-MM-DD")),
        title: title === "" ? null : title,
        to_date: to_date === "" ? null : fixNumbers(to_date.convert()?.format("YYYY-MM-DD")),
        number: number === "" ? null : number,
        national_code: national_code === "" ? null : national_code,
        first_name: first_name === "" ? null : first_name,
        last_name: last_name === "" ? null : last_name,
        plan_type:plan_type === "" ? null : plan_type,
      });
      if (response) {
        this.setState({ offersList: response?.data?.data, loading: false, openModal: false })
        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };

  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value })
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getList()
    }, 800);
  }
  resetTimeOut: string | number | NodeJS.Timeout | undefined;
  resetFilter = () => {
    this.setState({from_date: "",to_date: "",title: "",number: "",national_code: "",first_name: "",last_name : "" , plan_type:""}) 

    clearTimeout(this.resetTimeOut);
    this.resetTimeOut = setTimeout(() => {
      this.getList()
    }, 800);
  }
  async uploadFile () {
    const { uploadLoading , selecteditem, fileUpload , descr , uploadError} = this.state;
    const shebaCodeSchema = yup.object({
      fileUpload: yup.string().required("فایل اجباری می باشد"),
      descr: yup.string().required("توضیحات اجباری می باشد"),

    });
    try {
      this.setState({ loading: true })
      await shebaCodeSchema.validate({ descr , fileUpload}, { abortEarly: false });

      const response = await service.UniversalAttachment.create(
        {attachments:fileUpload,
          policy_id:selecteditem.id,
          descr:descr}
      );
      if (response) { 
        this.closeUploadModal();
        toast.success(response?.data?.message);
        this.setState({ loading: false })
      }

    } catch (err: any) {
      this.setState({
        uploadLoading: false,
        loading: false,
        uploadError: Array.isArray(err.inner) ? err.inner : []
      });
    }
  }


  async uploadImage(event: any) {
    const file = event.target.files[0];
  
    if (!file) {
      return; 
    }
    if (file.type === "image/svg+xml") {
      toast.error("آپلود فایل SVG مجاز نمی‌باشد.");
      return;
    }
    if (file.size === 0) {
      toast.error("آپلود فایل با حجم صفر مجاز نمی‌باشد.");
      return;
    }
    if (file.size > 1 * 1024 * 1024) {
      toast.error("حجم فایل نباید بیشتر از 1 مگابایت باشد.");
      return;
    }
  
    const reader = new FileReader();
    reader?.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({ file: reader.result });
    };
  
    this.setState({ fileUpload: file });
  }
  closeUploadModal = () =>{
    this.setState({ openUploadModal: !this.state.openUploadModal ,loading:false, uploadLoading: false , selecteditem : {} , descr : "" , fileUpload : "" , file:""  , uploadError:[] , plan_type : ""})
  }
}
export default OffersListController;